import type { FC, ReactElement } from 'react';

import { ScToggleSwitch } from './styled';

export type ToggleField = {
  value: string;
  label: ReactElement | string;
  isActive: boolean;
};

interface ToggleSwitchProps {
  fields: ToggleField[];
  handleToggle: (value: string) => void;
  horizontal?: boolean;
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({
  fields,
  handleToggle,
  horizontal = false,
}) => (
  <ScToggleSwitch horizontal={horizontal}>
    {fields.map(({ label, isActive, value }) => (
      <div
        className={`toggle-btn ${isActive ? 'toggle-btn__active' : ''}`}
        key={value}
        onClick={() => handleToggle(value)}
      >
        <span className="label">{label}</span>
      </div>
    ))}
  </ScToggleSwitch>
);
